import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { useSection } from "../../lib/content";

export const Steps = () => {
  const c = useSection("steps");

  return (
    <section id="migration-plan" className="relative bg-slate-50 py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionHead chapter="08" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="relative">
            <span className="absolute left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-[#024AD8]/50 via-[#333333] to-transparent" />
            <div className="space-y-4">
              {c.steps.map((step, i) => (
                <Reveal key={`${step.name}-${i}`} delay={i * 0.08}>
                  <div
                    data-testid={`migration-step-${String(i + 1).padStart(2, "0")}`}
                    className="group relative flex gap-6 rounded-2xl border border-[#2a2a2a] bg-[#1a1a1a] p-6 lg:p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#024AD8]/60 hover:shadow-[0_20px_44px_-20px_rgba(2,74,216,0.3)]"
                  >
                    <span className="relative z-10 shrink-0 w-14 h-14 rounded-2xl bg-[#024AD8] text-white grid place-items-center font-display font-extrabold text-lg tracking-tight transition-colors duration-300 group-hover:bg-[#FF5050]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <h3 className="font-display text-lg sm:text-xl font-bold tracking-tight text-white">
                        {step.name}
                      </h3>
                      <p className="mt-2 text-sm sm:text-base text-slate-400 leading-relaxed">{step.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
